import classNames from 'classnames';
import {
  Button,
  ErrorMessage,
  FlexContainer,
  LabeledInput,
  Spinner,
  TitledBlock,
} from 'components';
import { userTitleOptions } from 'config/userFields';
import { firstNameField, lastNameField, phoneField } from 'config/fieldsProps';
import { observer } from 'mobx-react-lite';
import { useProfile } from 'state';
import { useUserStateHelpers } from '../../hooks';
import styles from './EditProfile.module.scss';

/**
 * EditProfile
 *
 * @return {JSX.Element}
 */
const EditProfile = ({ className }) => {
  const profileState = useProfile();
  const { handleInput, handleSubmit, data, isDirty, isLoading, error } =
    useUserStateHelpers(profileState);

  return (
    <form
      className={classNames(
        styles.EditProfile,
        className,
        `${EditProfile.displayName}`
      )}
      onSubmit={handleSubmit}
    >
      <TitledBlock title="Personal details">
        <LabeledInput
          label="Title"
          name="title"
          onChange={handleInput}
          value={data.title || ''}
          disabled={isLoading}
          options={userTitleOptions}
          required
          select
        />
        <LabeledInput
          {...firstNameField}
          label="First name"
          value={data.firstName || ''}
          disabled={isLoading}
          onChange={handleInput}
        />
        <LabeledInput
          {...lastNameField}
          label="Last name"
          value={data.lastName || ''}
          disabled={isLoading}
          onChange={handleInput}
        />
        <LabeledInput
          label="Email address"
          name="emailAddress"
          type="email"
          defaultValue={data.emailAddress || ''}
          disabled={isLoading}
          readOnly
          required
        />
        <LabeledInput
          {...phoneField}
          label="Mobile"
          value={data.mobileNumber || ''}
          onChange={handleInput}
          disabled={isLoading}
        />
        {error ? <ErrorMessage small title={error} /> : null}
        {isDirty ? (
          <FlexContainer>
            <Button flex success type="submit" disabled={isLoading}>
              {isLoading ? <Spinner /> : 'Save'}
            </Button>
          </FlexContainer>
        ) : null}
      </TitledBlock>
    </form>
  );
};

EditProfile.displayName = 'EditProfile';

export default observer(EditProfile);
